function LocaleString (props) {
	props.isDirty = false;
  props.isCreated = (props.created_at !== null);
	this.props = props;
	return this;
}

export default LocaleString;


// WEBPACK FOOTER //
// ./src/Entities/LocaleString.js